import DDados from '../address.ddados';
import DDadosItem from '@common/components/ddados/ddados.item';
import React, { Fragment, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import AddressComponent from '@common/components/address/components/address.component';
import AddressBrasil from './address.brasil.component';
import AddressExterior from './address.exterior.component';
import { EnumTipoEndereco } from '../enums/tipoEndereco.enum';
import { EnumPaisEndereco } from '../enums/paisEndereco.enum';

function AddressGlobal(props) {
  const { Campos } = DDados;
  const { name, prefix, allowExterior, enderecoComum, canResetAddress } = props;
  const isView = prefix == 'V';

  const [TipoEndereco, setTipoEndereco] = useState(1);
  const [StateEndereco, setStateEndereco] = useState({});

  // Recebe o state do componente pai
  getDerivedStateFromProps(props);

  // foi criado um controle para pegar atualização do state, sem entrar em loop infinito
  function getDerivedStateFromProps(props) {
    let [prevState, setPrevState] = useState(null);

    if (canResetAddress ? false : props.state?.Cep == null) return;
    if (props.state !== prevState) {
      setPrevState(props.state);
      setStateEndereco(props.state);
      if (!!props.state?.Pais && props.state?.Pais != EnumPaisEndereco.Brasil) {
        setTipoEndereco(2);
      } else {
        setTipoEndereco(1);
      }
    }
  }

  // limpa o state quando mudar o TipoEndereco
  function onChangeTipoEndereco(value) {
    setTipoEndereco(value);
    props.onChangeTipoEndereco && props.onChangeTipoEndereco(value);
    if (!isView && !!StateEndereco.Cep) {
      setStateEndereco({});
    }
  }

  let Endereco = {
    TipoEndereco,
  };

  props = {
    ...props,
    state: StateEndereco,
  };

  return (
    <Fragment>
      {allowExterior && (
        <Row>
          <Col lg={6} style={{ marginLeft: '-13px', display: isView ? 'none' : '' }}>
            <DDadosItem
              name={name + '.TipoEndereco'}
              state={Endereco}
              isView={isView}
              stateName="TipoEndereco"
              {...Campos.TipoEndereco}
              onChange={(value) => onChangeTipoEndereco(value)}
            />
          </Col>
        </Row>
      )}
      {TipoEndereco == EnumTipoEndereco.Brasil && enderecoComum && (
        <Row>
          <Col lg={12}>
            <AddressComponent {...props} />
          </Col>
        </Row>
      )}
      {TipoEndereco == EnumTipoEndereco.Brasil && !enderecoComum && (
        <Row>
          <Col lg={12}>
            <AddressBrasil {...props} />
          </Col>
        </Row>
      )}
      {allowExterior && TipoEndereco == EnumTipoEndereco.Exterior && (
        <Row>
          <Col lg={12}>
            <AddressExterior {...props} />
          </Col>
        </Row>
      )}
    </Fragment>
  );
}

AddressGlobal.defaultProps = {
  allowExterior: true,
};

export default AddressGlobal;
